<template>
  <div>
    <AdminEditForm action="create" @save="save"></AdminEditForm>
  </div>
</template>

<script>
import AdminEditForm from './AdminEditForm.vue';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'AdminCreatePage',
  components: {
    AdminEditForm
  },
  computed: {
    ...mapState({ userData: (state) => state.profile.profileData })
  },
  created() {
    this.SET_ADMIN({});
  },
  methods: {
    ...mapActions(['createAdmin']),
    ...mapMutations(['SET_ADMIN']),
    save(admin) {
      const info = {
        admin,
        notification: {
          type: 'success',
          message: `feedback.success.updateClient`,
          show: true
        }
      };
      const adminData = this.createAdmin(info);
      setTimeout(() => {
        if (adminData) {
          this.$router.push({ name: 'admins' });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 2000);
    }
  }
};
</script>
